import axios from 'axios';
import {config} from '../shared/app.config';

const RESOURCE_NAME = '/landing';

export default {
  sendForm (form) {
    return axios.post(`${config.webApiBase + RESOURCE_NAME  }/form`, form);
  }
}
